import React, {useEffect, useState} from 'react';
import {DirectoryBar} from '../../components/DirectoryBar';
import {Button} from '../../components/Button';
import {H3} from '../../components/H3';
import {TextArea} from '../../components/TextArea';
import {deleteCustomers, getCustomerBoardDetail, postReCustomers} from "../../apis/user";
import {useHistory, useParams} from "react-router-dom";
import {CustomerBoardDetailDto} from "../../types/types";
import {ReactComponent as FileClip} from '../../assets/svg/file-clip.svg'

export const InquireDetail = () => {
    const {id} = useParams<{ id: string }>()
    const customerBoardId = parseInt(id)
    const [detail, setDetail] = useState<CustomerBoardDetailDto>()
    const [content, setContent] = useState<string>('')
    const [hasManagerAnswer, setHasManagerAnswer] = useState<boolean>(false)

    const history = useHistory()

    useEffect(() => {
        getList()
    }, [])

    useEffect(() => {
      if (detail) {
        const copiedReplies = [...detail.replies]
        const latestReply = copiedReplies.sort((a, b) => (+new Date(a.createdAt)) - (+new Date(b.createdAt)))[copiedReplies.length - 1]
        setHasManagerAnswer(latestReply?.isManagerAnswer)
      }
    }, [detail])

    const getList = () => {
        getCustomerBoardDetail(customerBoardId).then(r => setDetail(r.data.payload)).catch(e => console.log(e))
    }

    const onSubmit = () => {
        postReCustomers(customerBoardId, content).then(r => {
            getList();
            setContent('');
        }).catch(e => console.log(e));
    }

    const deleteThis = () => {
        deleteCustomers(customerBoardId).then(r => history.goBack()).catch(e => console.log(e))
    }

    if (!detail) return null
    return (
        <>
            <DirectoryBar text="" backArrow className="md:hidden border-none"/>
            <div className="space-y-5">
                <div className="border-b border-gray-800 pb-4 flex justify-between items-center">
                    <H3 className="">{detail.title}</H3>
                    <Button text="삭제"
                            onClick={deleteThis}
                            className="outlined-red-500 px-10 text-sm font-light min-w-max ml-2"
                    />
                </div>
                <div className={'border-b border-gray-800 py-4'}>
                    <p className={'font-bold'}>문의사항</p>
                    <p style={{whiteSpace: 'pre-wrap'}}>{detail.contents}</p>
                    {detail.attachmentUrls.map((item, index) => (
                        <div className={'flex items-center pt-4'} key={index}>
                            <FileClip/>
                            <p className={'text-gray-600 ml-3'}>
                                첨부파일 {index + 1}
                                <a href={item} key={index} className={'m-3 text-blue-500'}>다운로드</a>
                            </p>
                        </div>
                    ))}
                </div>
            </div>
            <div className="py-5 space-y-5">
                {detail.replies.map((item, index) => (
                    <div className="text-14" key={index}>
                        <label className=" font-semibold">{item.isManagerAnswer ? '답변' : '재문의'}</label>
                        <div className="" style={{whiteSpace: 'pre-wrap'}}>{item.contents}</div>
                    </div>
                ))}

                {hasManagerAnswer && (
                <div className="space-y-5">
                    <TextArea
                        label="재문의"
                        placeholder="내용을 입력해주세요."
                        className="h-24"
                        value={content}
                        onChange={e => setContent(e.target.value)}
                    />

                    <div className="flex flex-row-reverse">
                        <Button disabled={!content}
                                text="등록하기"
                                onClick={onSubmit}
                                className="filled-black px-16 text-sm font-light"
                        />
                    </div>
                  </div>
                )}
            </div>
        </>
    );
};
